export const TOGGLE_SELECTED = 'TOGGLE_SELECTED';
export const CLEAR_SELECTED = 'CLEAR_SELECTED';
export const TOGGLE_ALL_ROW_SELECTED = 'TOGGLE_ALL_ROW_SELECTED';



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/mutation-types.js